/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyPharmacyHours,
  PharmacyPharmacyHoursFromJSON,
  PharmacyPharmacyHoursFromJSONTyped,
  PharmacyPharmacyHoursToJSON,
  PharmacyRecurringCalendar,
  PharmacyRecurringCalendarFromJSON,
  PharmacyRecurringCalendarFromJSONTyped,
  PharmacyRecurringCalendarToJSON,
} from "./";

export const PharmacyPharmacyBusinessHoursUpdatableTypename = "PharmacyPharmacyBusinessHoursUpdatable" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacyBusinessHoursUpdatable
 */
export interface PharmacyPharmacyBusinessHoursUpdatable {
  /**
   *
   * @type {Array<string>}
   * @memberof PharmacyPharmacyBusinessHoursUpdatable
   */
  closedDays?: Array<string>;
  /**
   *
   * @type {PharmacyPharmacyHours}
   * @memberof PharmacyPharmacyBusinessHoursUpdatable
   */
  counselingReceptionHours?: PharmacyPharmacyHours;
  /**
   *
   * @type {Array<PharmacyRecurringCalendar>}
   * @memberof PharmacyPharmacyBusinessHoursUpdatable
   */
  counselingRecurringCalendars?: Array<PharmacyRecurringCalendar>;
  /**
   *
   * @type {PharmacyPharmacyHours}
   * @memberof PharmacyPharmacyBusinessHoursUpdatable
   */
  dispensingReceptionHours?: PharmacyPharmacyHours;
  /**
   *
   * @type {Array<PharmacyRecurringCalendar>}
   * @memberof PharmacyPharmacyBusinessHoursUpdatable
   */
  dispensingRecurringCalendars?: Array<PharmacyRecurringCalendar>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacyBusinessHoursUpdatable
   */
  readonly __typename?: string;
}

export function PharmacyPharmacyBusinessHoursUpdatableFromJSON(json: any): PharmacyPharmacyBusinessHoursUpdatable {
  return PharmacyPharmacyBusinessHoursUpdatableFromJSONTyped(json, false);
}

export function PharmacyPharmacyBusinessHoursUpdatableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPharmacyBusinessHoursUpdatable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacyBusinessHoursUpdatableTypename,

    closedDays: !exists(json, "closed_days") ? undefined : json["closed_days"],
    counselingReceptionHours: !exists(json, "counseling_reception_hours")
      ? undefined
      : PharmacyPharmacyHoursFromJSON(json["counseling_reception_hours"]),
    counselingRecurringCalendars: !exists(json, "counseling_recurring_calendars")
      ? undefined
      : (json["counseling_recurring_calendars"] as Array<any>).map(PharmacyRecurringCalendarFromJSON),
    dispensingReceptionHours: !exists(json, "dispensing_reception_hours")
      ? undefined
      : PharmacyPharmacyHoursFromJSON(json["dispensing_reception_hours"]),
    dispensingRecurringCalendars: !exists(json, "dispensing_recurring_calendars")
      ? undefined
      : (json["dispensing_recurring_calendars"] as Array<any>).map(PharmacyRecurringCalendarFromJSON),
  };
}

export function PharmacyPharmacyBusinessHoursUpdatableToJSON(
  object?: PharmacyPharmacyBusinessHoursUpdatable | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    closed_days: value.closedDays,
    counseling_reception_hours: PharmacyPharmacyHoursToJSON(value.counselingReceptionHours),
    counseling_recurring_calendars:
      value.counselingRecurringCalendars === undefined
        ? undefined
        : (value.counselingRecurringCalendars as Array<any>).map(PharmacyRecurringCalendarToJSON),
    dispensing_reception_hours: PharmacyPharmacyHoursToJSON(value.dispensingReceptionHours),
    dispensing_recurring_calendars:
      value.dispensingRecurringCalendars === undefined
        ? undefined
        : (value.dispensingRecurringCalendars as Array<any>).map(PharmacyRecurringCalendarToJSON),
  };
}
